import React from "react";
import { inject, observer } from "mobx-react";
import { Badge } from "react-bootstrap";
import DatePicker from "react-datepicker";

@inject("searchStore")
@observer
export class SearchFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFrameworks: [],
    };
  }

  handleClick = (type) => {
    const { toggleFilter } = this.props.searchStore;
    toggleFilter(type);
  };

  handleCubeTypeChange = (options) => {
    const { setSelectedCubeTypes } = this.props.searchStore;
    setSelectedCubeTypes(options.map((option) => option.value));
  };

  clearFilters() {
    this.props.searchStore.clearFilters();
  }

  getClassName = (type) => {
    const { getSelectedTypes } = this.props.searchStore;
    if (!getSelectedTypes.length) {
      return "none";
    } else if (getSelectedTypes.findIndex((value) => value === type) !== -1) {
      return "selected";
    }
  };

  render() {
    const {
      filtersVisible,
      getObjectTypes,
      getSelectedTypes,
      getSelectedDate,
      setSelectedDate,
    } = this.props.searchStore;

    if (!filtersVisible) {
      return null;
    }

    return (
      <div className="search-filters">
        <div className="types-container">
          <label>Type: </label>
          {getObjectTypes.map((type) => (
            <Badge
              key={type}
              className={this.getClassName(type)}
              onClick={() => this.handleClick(type)}
            >
              {type}
            </Badge>
          ))}
          {getSelectedTypes.length ? (
            <Badge className="clear" onClick={() => this.clearFilters()}>
              Clear filters
            </Badge>
          ) : (
            ""
          )}
        </div>
        <div className="validity-date-container">
          <label>Validity Date: </label>
          <DatePicker
            className="cm-quickfilter-datapicker"
            dateFormat="yyyy-MM-dd"
            selected={getSelectedDate || null}
            onChange={(date) => setSelectedDate(date)}
            withPortal
            isClearable
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            placeholderText="Today"
          />
        </div>
      </div>
    );
  }
}
